var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const initialState = {
    isLogedIn: false,
    id: 0,
    first_name: "",
    last_name: "",
    company_name: "",
    is_subscription_user: false,
    profile_image_url: "",
    is_id_file_confirmed: false,
};
//非同期の処理を記載-ログイン時の処理
export const loginAsync = createAsyncThunk("company/fetchActions", (data) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield axios.post("/api/company/login", data);
    return {
        id: result.data.id,
        first_name: result.data.first_name,
        last_name: result.data.last_name,
        company_name: result.data.company_name,
        is_subscription_user: Boolean(result.data.is_subscription_user),
        profile_image_url: result.data.profile_image_url,
        is_id_file_confirmed: Boolean(result.data.is_confirmed_document)
    };
}));
//非同期の処理を記載-authチェックの処理
export const listenCompanyAsync = createAsyncThunk("company/authCheck", () => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield axios.get("/api/company/current_company");
    return {
        id: result.data.id,
        first_name: result.data.first_name,
        last_name: result.data.last_name,
        company_name: result.data.company_name,
        is_subscription_user: Boolean(result.data.is_subscription_user),
        profile_image_url: result.data.profile_image_url,
        is_id_file_confirmed: Boolean(result.data.is_confirmed_document)
    };
}));
//非同期の処理を記載-ログアウト処理
export const logoutAsync = createAsyncThunk("company/logout", () => __awaiter(void 0, void 0, void 0, function* () {
    yield axios.get("/api/company/logout");
}));
const companyAuthSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {
        loginAction(state, action) {
            state = action.payload;
        },
        enableSubscriptionUserAction(state) {
            state.is_subscription_user = true;
            return state;
        },
        unableSubscriptionUserAction(state) {
            state.is_subscription_user = false;
            return state;
        },
        changeProfileImageAction(state, action) {
            state.profile_image_url = action.payload;
            return state;
        },
        resetCompanyAction(state) {
            return state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAsync.pending, (state) => {
        })
            .addCase(loginAsync.fulfilled, (state, action) => {
            const newState = {
                isLogedIn: true,
                id: action.payload.id,
                first_name: action.payload.first_name,
                last_name: action.payload.last_name,
                company_name: action.payload.company_name,
                is_subscription_user: action.payload.is_subscription_user,
                profile_image_url: action.payload.profile_image_url,
                is_id_file_confirmed: action.payload.is_id_file_confirmed
            };
            return state = newState;
        })
            .addCase(loginAsync.rejected, (state) => {
            throw "error";
        })
            .addCase(listenCompanyAsync.pending, (state) => {
        })
            .addCase(listenCompanyAsync.fulfilled, (state, action) => {
            var _a;
            const newState = {
                isLogedIn: true,
                id: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.id,
                first_name: action.payload.first_name,
                last_name: action.payload.last_name,
                company_name: action.payload.company_name,
                is_subscription_user: action.payload.is_subscription_user,
                profile_image_url: action.payload.profile_image_url,
                is_id_file_confirmed: action.payload.is_id_file_confirmed
            };
            return state = newState;
        })
            .addCase(listenCompanyAsync.rejected, (state) => {
            throw "error";
            //const newState = {
            //    isLogedIn: false,
            //    id: 0,
            //    name: ""
            //}
            //return state = newState
        })
            .addCase(logoutAsync.pending, (state) => {
        })
            .addCase(logoutAsync.fulfilled, (state) => {
            return state = initialState;
        })
            .addCase(logoutAsync.rejected, (state) => {
            throw "error";
        });
    }
});
//Actions
export const { loginAction, enableSubscriptionUserAction, unableSubscriptionUserAction, changeProfileImageAction, resetCompanyAction } = companyAuthSlice.actions;
export default companyAuthSlice;
